import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useUmoPromoteStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flex: '1 0 300px',
      margin: theme.spacing(2),
    },
    paperRoot: {
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
    },
    headingRoot: {
      marginBottom: theme.spacing(1),
    },
    contentRoot: {
      textAlign: 'center',
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  }),
);
